import {gql} from '@apollo/client'

export const GET_PWP_BY_ID = gql`
  query ($user: uuid) {
    people_work_placements(where: {global_user: {id: {_eq: $user}}}) {
      id
    }
  }
`
